// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"552dff9e","378":"02bb30cd","488":"ebf2f1b8"}[chunkId] + ".chunk.js";
};